import { JetView } from 'webix-jet';
import { devConfig, countries, providersCasino, subprovidersCasino, gamesCasino, profile } from 'config/config';

/**
 * Class representing a view for filtering products.
 * @extends JetView
 */
export default class FilterProductsView extends JetView {
    /**
     * Configures the layout of the filter products view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._;
        const screen = this.app.config.size;

        // Options for device type selection
        var options = [
            { id: 1, value: 'Mobile', icon: 'pe' },
            { id: 2, value: 'Desktop', icon: 'pe' },
            { id: 3, value: _('Ambos'), icon: 'pe' },
        ];

        // Left section of the filter form
        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text',
                            name: 'Name',
                            label: "<span class='icon-user'></span>" + _('Nombre'),
                            labelPosition: 'top',
                            placeholder: _('Nombre'),
                            invalidMessage: _('Nombre is required'),
                        },
                        {
                            view: 'richselect',
                            name: 'IsActivate',
                            label: "<span class='icon-state'></span>" + _('Estado'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: '', value: _('Todos') },
                                { id: 'A', value: _('Activado') },
                                { id: 'I', value: _('Inactivado') },
                            ],
                        },
                        {
                            view: 'combo',
                            name: 'ProviderId',
                            localId: 'provider:combo',
                            label: _('Proveedor'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: {
                                body: {
                                    dataFeed: function (text) {
                                        var vthis = this;
                                        if (text.length > 2) {
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'es/Select/ProvidersCasinoSelect',
                                                    '{"Filter":"' + text + '"}',
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message('Error! ');
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var resp = JSON.parse(text);
                                                            if (!resp.HasError) {
                                                                vthis.parse(resp.Data);
                                                            }
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            },
                        },
                        {
                            view: 'combo',
                            name: 'SubProviderId',
                            localId: 'subProvider:combo',
                            label: _('Sub Proveedor'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: {
                                body: {
                                    dataFeed: function (text) {
                                        var vthis = this;
                                        if (text.length > 2) {
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'es/Select/SubProvidersCasinoSelect',
                                                    '{"Filter":"' + text + '"}',
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message('Error! ');
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var resp = JSON.parse(text);
                                                            if (!resp.HasError) {
                                                                vthis.parse(resp.Data);
                                                            }
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            },
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'combo',
                            name: 'ProductId',
                            localId: 'product:combo',
                            label: _('Producto'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: {
                                body: {
                                    dataFeed: function (text) {
                                        var vthis = this;
                                        if (text.length > 2) {
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'es/Select/GamesCasinoSelect',
                                                    '{"Filter":"' + text + '"}',
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message('Error! ');
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var resp = JSON.parse(text);
                                                            if (!resp.HasError) {
                                                                vthis.parse(resp.Data);
                                                            }
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            },
                        },
                        {
                            view: 'radio',
                            name: 'TypeDevice',
                            label: _('Dispositivo'),
                            labelPosition: 'top',
                            value: 3,
                            options: [
                                {
                                    id: 1,
                                    value: "<span class='icon-phone'></span>",
                                },
                                {
                                    id: 2,
                                    value: "<span class='icon-display'></span>",
                                },
                                { id: 3, value: _('Ambos') },
                            ],
                        },
                        {
                            view: 'richselect',
                            name: 'Category',
                            localId: 'categorie:combo',
                            label: "<span class='icon-category'></span>" + _('Categorías'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            id: 'Categorie',
                            options: [],
                        },
                    ],
                },
            ],
        };

        // Second left section of the filter form
        const left2 = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text',
                            name: 'Id',
                            type: 'number',
                            label: "<span class='icon-id'></span>" + _('Producto Id'),
                            labelPosition: 'top',
                            placeholder: _('Producto Id'),
                        },
                        {
                            view: 'richselect',
                            name: 'IsVerified',
                            label: "<span class='icon-verified_user'></span>" + _('Verificado'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: 'null', value: 'Todos' },
                                { id: 'A', value: 'Activado' },
                                { id: 'I', value: 'Inactivado' },
                            ],
                        },
                        {
                            view: 'text',
                            name: 'ExternalId',
                            label: "<span class='icon-id'></span>" + _('ID Externo'),
                            labelPosition: 'top',
                            placeholder: _('ID Externo'),
                            invalidMessage: _('External ID is required'),
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'richselect',
                            name: 'Visible',
                            label: "<span class='icon-eye-slash'></span>" + _('Visible'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: '', value: _('Todos') },
                                { id: 'A', value: _('Activado') },
                                { id: 'I', value: _('Inactivado') },
                            ],
                        },
                        { id: 'grav3', gravity: 2 },
                    ],
                },
            ],
        };

        // Upper section of the filter form
        const upper_section = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 360 : 0,
            rows: [
                {
                    margin: 10,
                    cols: [left],
                },
            ],
        };

        // Second upper section of the filter form
        const upper_section2 = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 260 : 0,
            rows: [
                {
                    margin: 10,
                    cols: [left2],
                },
            ],
        };

        // Accordion section for advanced filters
        const accordion_section = {
            id: 'b5',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros Avanzados'),
                            body: {
                                padding: 10,
                                rows: [upper_section2],
                            },
                        },
                    ],
                },
            ],
        };

        // Buttons section for actions
        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 3 },
                        {
                            minWidth: 200,
                            view: 'button',
                            value: _('Productos Masivo'),
                            type: 'form',
                            width: screen == 'small' ? 0 : 150,
                            hidden: !devConfig.getPermAction('productsMassive', 'Add'),
                            css: 'prm-productsMassive',
                            click: () => {
                                /**
                                 * Converts a file to Base64 format.
                                 * @param {File} file - The file to convert.
                                 * @returns {Promise} A promise that resolves with the Base64 string.
                                 */
                                function getBase64(file) {
                                    return new Promise((resolve, reject) => {
                                        const reader = new FileReader();
                                        reader.readAsDataURL(file);
                                        reader.onload = () => resolve(reader.result);
                                        reader.onerror = (error) => reject(error);
                                    });
                                }
                                var base64CSV2 = '';
                                webix
                                    .ui({
                                        view: 'window',
                                        id: 'ProductsMassive',
                                        fullscreen: screen.width < 500 ? true : false,
                                        head: {
                                            view: 'toolbar',
                                            cols: [
                                                {
                                                    view: 'label',
                                                    label: _('Agregar Productos Masivos'),
                                                },
                                                {
                                                    view: 'icon',
                                                    icon: 'wxi-close',
                                                    click: function () {
                                                        this.getTopParentView().hide();
                                                    },
                                                },
                                            ],
                                        },
                                        position: 'center',
                                        modal: true,
                                        body: {
                                            view: 'form',
                                            id: 'productsMassiveForm',
                                            elements: [
                                                {
                                                    margin: 10,
                                                    rows: [
                                                        {
                                                            view: 'uploader',
                                                            id: 'uploader4',
                                                            value: _('Cargar archivo CSV'),
                                                            on: {
                                                                onBeforeFileAdd: function (upload) {
                                                                    // Convert the selected CSV file to Base64 so it can be sent to the API as part of the JSON request
                                                                    getBase64(upload.file).then(
                                                                        (data) => (base64CSV2 = data),
                                                                    );

                                                                    // Update the uploader label to display the name of the selected CSV file
                                                                    $$('uploader4').define('label', upload.name);

                                                                    // Refresh the uploader to apply the updated label
                                                                    $$('uploader4').refresh();
                                                                },
                                                            },
                                                        },
                                                    ],
                                                },
                                                {
                                                    cols: [
                                                        {
                                                            view: 'button',
                                                            value: _('Cancelar'),
                                                            click: function () {
                                                                // Close the bulk product upload form without submitting the selected CSV file
                                                                this.getTopParentView().hide();

                                                                // Reset all form fields to their initial clean values
                                                                $$('productsMassiveForm').setValues(
                                                                    $$('productsMassiveForm').getCleanValues(),
                                                                );

                                                                // Restore the default uploader label for a new CSV upload
                                                                $$('uploader4').define(
                                                                    'label',
                                                                    _('Cargar archivo CSV'),
                                                                );

                                                                // Refresh the uploader to display the default label
                                                                $$('uploader4').refresh();

                                                                // Clear the stored Base64 CSV data to prevent the previous file from being submitted again
                                                                base64CSV2 = '';
                                                            },
                                                        },
                                                        {
                                                            view: 'button',
                                                            type: 'form',
                                                            value: _('Guardar'),
                                                            click: function ($e) {
                                                                // Retrieve the current values from the bulk product form
                                                                var values = $$('productsMassiveForm').getValues();

                                                                // Validate the form fields and verify that a CSV file has been selected and converted to Base64
                                                                if (
                                                                    $$('productsMassiveForm').validate() &&
                                                                    base64CSV2 != ''
                                                                ) {
                                                                    // Create an AJAX request to submit the CSV file to the bulk product creation endpoint
                                                                    webix
                                                                        .ajax()

                                                                        // Set the request content type to JSON because the CSV is sent inside a JSON object
                                                                        .headers({
                                                                            'Content-type': 'application/json',
                                                                        })

                                                                        // Send the Base64-encoded CSV to the Product/BulkAddProducts API endpoint
                                                                        .post(
                                                                            devConfig.geturlApi() +
                                                                                'Product/BulkAddProducts',
                                                                            '{"CSV":"' + base64CSV2 + '"}',

                                                                            {
                                                                                error: function (
                                                                                    text,
                                                                                    data,
                                                                                    XmlHttpRequest,
                                                                                ) {
                                                                                    // Display a generic error message when the API request fails
                                                                                    webix.message('Error! ');
                                                                                },

                                                                                success: function (
                                                                                    text,
                                                                                    data,
                                                                                    XmlHttpRequest,
                                                                                ) {
                                                                                    // Parse the API response from a JSON string into a JavaScript object
                                                                                    text = JSON.parse(text);

                                                                                    // Check whether the API reported an error while processing the CSV file
                                                                                    if (text.HasError) {
                                                                                        // Display the error message returned by the API
                                                                                        webix.message(
                                                                                            'Error: ' +
                                                                                            text.AlertMessage,
                                                                                        );

                                                                                        // Check whether the API returned duplicated games in the data collection
                                                                                    } else if (
                                                                                        text.data &&
                                                                                        text.data.length > 0
                                                                                    ) {
                                                                                        // Extract the game name from each duplicated game returned by the API
                                                                                        const duplicatedGames =
                                                                                            text.data.map((game) => {
                                                                                                return game.Nombre
                                                                                                    .split(';')[0]
                                                                                                    .trim();
                                                                                            });

                                                                                        // Display a warning message listing all duplicated games found in the CSV file
                                                                                        webix.message({
                                                                                            title: _(
                                                                                                '¡Juegos repetidos!',
                                                                                            ),
                                                                                            type: 'alert-warning',
                                                                                            text: _(
                                                                                                'Los siguientes juegos están repetidos: ' +
                                                                                                duplicatedGames.join(
                                                                                                    ', ',
                                                                                                ),
                                                                                            ),
                                                                                        });

                                                                                        // If the API does not report errors or duplicated games, display the successful creation message
                                                                                    } else {
                                                                                        webix.message(
                                                                                            'Productos Masivos Creados',
                                                                                        );
                                                                                    }
                                                                                },
                                                                            },
                                                                        );

                                                                    // Close the bulk product upload form after the request has been submitted
                                                                    this.getTopParentView().hide();
                                                                } else {
                                                                    // Display a validation error when the form is incomplete or no CSV file has been uploaded
                                                                    webix.message({
                                                                        title: _('¡Error!'),
                                                                        type: 'alert-error',
                                                                        text: _('Completa los campos...'),
                                                                    });
                                                                }
                                                            },
                                                        },
                                                    ],
                                                },
                                            ],
                                            elementsConfig: {
                                                on: {
                                                    onChange: function () {
                                                        this.validate();
                                                    },
                                                },
                                            },
                                        },
                                    })
                                    .show();
                            },
                        },
                        {
                            minWidth: 200,
                            view: 'button',
                            value: _('Añadir Producto'),
                            type: 'form',
                            width: screen == 'small' ? 0 : 150,
                            hidden: !devConfig.getPermAction('ProductsAdd', 'Add'),
                            css: 'prm-ProductsAdd',
                            click: () => {
                                this.app.callEvent('addProduct:button', [[]]);
                            },
                        },
                        {
                            minWidth: 200,
                            view: 'button',
                            value: _('Limpiar'),
                            width: screen == 'small' ? 0 : 100,
                            click: () => {
                                this.getRoot().clear();
                            },
                        },
                        {
                            minWidth: 200,
                            view: 'button',
                            value: _('Consultar'),
                            type: 'form',
                            width: screen == 'small' ? 0 : 100,
                            click: () => {
                                const filterdata = this.getRoot().getValues();
                                this.app.callEvent('products:filter', [filterdata]);
                                $$('b1').collapse();
                                $$('a5').scrollTo(100, 0);
                            },
                        },
                    ],
                },
            ],
        };

        // Accordion section for filters
        const accordion_section1 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'),
                            id: 'b1',
                            body: {
                                padding: 10,
                                rows: [upper_section, accordion_section, buttons],
                            },
                        },
                    ],
                },
            ],
        };

        // Return the main form configuration
        return {
            view: 'form',
            type: 'clean',
            rows: [accordion_section1],
            rules: {
                fname: webix.rules.isNotEmpty,
            },
        };
    }

    /**
     * Initializes the view and loads categories data.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500) {
                $$('grav').hide();
                $$('grav3').hide();
            }
            webix
                .ajax()
                .headers({
                    'Content-type': 'application/json',
                })
                .post(
                    devConfig.geturlApi() + 'Categories/GetCategories',
                    { global: true },
                    {
                        error: function (text, data, XmlHttpRequest) {
                            webix.message('Error! ');
                        },
                        success: function (text, data, XmlHttpRequest) {
                            var resp = JSON.parse(text);
                            for (var i = 0; i < resp.data.length; i++) {
                                resp.data[i].id = resp.data[i].Id;
                                resp.data[i].value = resp.data[i].Description;
                            }
                            $$('Categorie').define('options', resp.data);
                            $$('Categorie').refresh();
                        },
                    },
                );
        });
    }
}

// FILE DOCUMENTED
